class SamplesDrawer extends HTMLElement {
    constructor() {
        super();
        this.startY = 0;
        this.currentY = 0;
        this.isDragging = false;
    }

    connectedCallback() {
        this.cartItems = document.querySelector("cart-items");
        this.cartDrawer = document.querySelector("cart-drawer");
        this.samplesDrawer = this.querySelector('[data-samples-drawer]');
        this.samplesTrigger = this.querySelector('[data-samples-trigger]');
        this.samplesCloseButtons = this.querySelectorAll('[data-samples-close]');
        this.gestureArea = this.querySelector('[data-gesture-area]') || this.samplesDrawer;

        this.sectionId = this.cartDrawer.getAttribute("data-section-id");
        this.freeSampleMin = this.getAttribute("data-free-sample-min");

        this.setupDrawer();
        this.setupRemoveSampleButtons();
        this.setupGesture();
        this.deleteAllSamples();
    }

    setupDrawer() {
        if (this.samplesTrigger) {
            this.samplesTrigger.addEventListener('click', () => {
                if (!this.samplesTrigger.disabled) {
                    this.samplesDrawer.classList.add('is-open');
                    document.body.style.overflow = 'hidden';
                }
            });
        }

        this.samplesCloseButtons.forEach((button) => {
            button.addEventListener('click', () => this.closeDrawer());
        });

        document.addEventListener('click', (event) => {
            if (!this.samplesDrawer.classList.contains('is-open')) return;

            const isClickInside = this.samplesDrawer.contains(event.target) || this.samplesTrigger.contains(event.target);
            if (!isClickInside) {
                this.closeDrawer();
            }
        });
    }


    closeDrawer() {
        this.samplesDrawer.classList.remove('is-open');
        this.samplesDrawer.style.transform = '';
        document.body.style.overflow = '';
    }

    setupRemoveSampleButtons() {
        this.querySelectorAll('.btn-remove-sample').forEach((button) => {
            button.addEventListener('click', async () => {
                const cartItemId = button.getAttribute("data_cart_item_id");
                button.disabled = true;
                const buttonToremove = this.cartItems.querySelector(`.item-${cartItemId}`);
                buttonToremove.click();
            });
        });
    }

    setupGesture() {
        if (!this.gestureArea) return;

        this.gestureArea.addEventListener('touchstart', (e) => {
            this.startY = e.touches[0].clientY;
            this.isDragging = true;
            this.samplesDrawer.style.transition = 'none';
        });

        this.gestureArea.addEventListener('touchmove', (e) => {
            if (!this.isDragging) return;
            this.currentY = e.touches[0].clientY;
            const deltaY = this.currentY - this.startY;

            if (deltaY > 0) {
                this.samplesDrawer.style.transform = `translateY(${deltaY}px)`;
            }
        });

        this.gestureArea.addEventListener('touchend', () => {
            this.isDragging = false;
            const deltaY = this.currentY - this.startY;

            this.samplesDrawer.style.transition = 'transform 0.25s ease, opacity 0.25s ease';

            if (deltaY > 120) {
                this.samplesDrawer.style.transform = `translateY(100%)`;
                this.samplesDrawer.style.opacity = '0';

                this.samplesDrawer.addEventListener('transitionend', () => {
                    this.samplesDrawer.classList.remove('is-open');
                    this.samplesDrawer.style.transform = '';
                    this.samplesDrawer.style.opacity = '';
                    document.body.style.overflow = '';
                }, { once: true });

            } else {
                this.samplesDrawer.style.transform = '';
                this.samplesDrawer.style.opacity = '1';
            }
        });

    }

    deleteAllSamples() {
        if (!window.__removingSampleItems) window.__removingSampleItems = false;

        document.addEventListener('cart:updated', async (e) => {
            if (window.__removingSampleItems) return;

            const cart = e.detail.cart;
            const samples = cart.items.filter(item => item.product_type.toLowerCase() === 'sample');

            if (cart.total_price < parseInt(this.freeSampleMin) && samples.length > 0) {
                window.__removingSampleItems = true;

                const sections = this.sectionId ? [this.sectionId] : [];

                for (const sample of samples) {
                    const payload = { id: sample.key, quantity: 0, sections };

                    try {
                        await fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(payload)
                        });
                    } catch (err) {
                        console.error(err);
                    }
                }

                document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
                setTimeout(() => { window.__removingSampleItems = false; }, 500);
            }
        });
    }
}

customElements.define('samples-drawer', SamplesDrawer);
